import {Shower} from "../../parts/shower";
import {SIDE_POSITIONS} from "../../constants";
import AccessoryCommon from "./accessoryCommon";

export default class LargeCornerSeat extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'large_corner_seat';
    this.partName = 'Large Corner Seat';
    this.translateId = "visualizer.bathroom.accessories.large_corner_seat";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [SIDE_POSITIONS[0]]: null,
        [SIDE_POSITIONS[1]]: null,
      };
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    const partNumber = dbFeature.metaData["layerPosition"] === SIDE_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new LargeCornerSeat(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    Object.keys(this.layerPositions).forEach(position => {
      if (this.layerPositions[position] && this.layerPositions[position].metaData["layerPosition"]) {
        this.checkRelatedFeatureGroupPositions(this.layerPositions[position].metaData["layerPosition"]);
      }
    })
  }

  handleClick() {
    const parent = this.getParent();
    // const accessoriesParent = parent.getParent(); // it is removing corner shelf! but it shouldn't
    // accessoriesParent.caddie_type = this.partId;
    parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"]);
    super.handleClick();
  }

  setLayers(layout) {

    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerTubComboIsActive()) { //  shower tub combo - remove
      super.hideLayers();
      return;
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      // this.checkIfFeaturePartIsMatching();
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      Object.keys(this.layerPositions).forEach((key, keyIndex) => {
        if (this.layerPositions[key]) {
          this.layerPositions[key].layer.zIndex = zIndexes.Accessories.LargeCornerSeat + keyIndex*10;
        }
      })
    }
  }

}

